export default "__VITE_ASSET__Dg4sD5Lz__"